// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payvendor_scanqrcard__WY-kT,
.payvendor_enterposidcard__LvL3m {
  width: 50%;
  height: 204px;
  padding: 32px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  color: white;
}
.payvendor_scanqrcard__WY-kT .payvendor_imgbox__Xapg5,
.payvendor_enterposidcard__LvL3m .payvendor_imgbox__Xapg5 {
  width: 56px;
  height: 56px;
  background-color: white;
  display: grid;
  place-content: center;
  border-radius: 8px;
}

.payvendor_scanqrcard__WY-kT {
  background: linear-gradient(276.1deg, #3082D4 0.31%, #47B7E8 100%);
}

.payvendor_enterposidcard__LvL3m {
  background: linear-gradient(276.1deg, #3A41C8 0.31%, #935FE5 100%);
}

.payvendor_myApproval__Qkqf1 {
  border-radius: 24px;
  padding: 20px 40px;
  margin-top: 50px;
  background: linear-gradient(276.1deg, #3A41C8 0.31%, #935FE5 100%);
  display: flex;
  color: white;
  justify-content: space-between;
  align-items: center;
  height: 160px;
}
.payvendor_myApproval__Qkqf1 img {
  height: 97px !important;
}
.payvendor_myApproval__Qkqf1 .payvendor_status__CACc9 {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #6D5E00;
  background-color: rgba(231, 205, 61, 0.8);
  border-radius: 8px;
  padding: 0 5px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/PayVendors/payvendor.module.scss"],"names":[],"mappings":"AAAA;;EAEI,UAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AACI;;EACI,WAAA;EACA,YAAA;EAEA,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AACR;;AAIA;EACI,kEAEI;AAHR;;AAMA;EACI,kEACI;AAJR;;AAOA;EAEI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kEAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AALJ;AAMA;EACI,uBAAA;AAJJ;AAMI;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACR,cAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AALA","sourcesContent":[".scanqrcard,\n.enterposidcard {\n    width: 50%;\n    height: 204px;\n    padding: 32px;\n    gap: 24px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 24px;\n    color: white;\n\n    .imgbox {\n        width: 56px;\n        height: 56px;\n        // padding: 12px 0px 0px 0px;\n        background-color: white;\n        display: grid;\n        place-content: center;\n        border-radius: 8px;\n\n    }\n}\n\n.scanqrcard {\n    background:\n        // linear-gradient(298.54deg, #074294 0%, #529CE4 100%),\n        linear-gradient(276.1deg, #3082D4 0.31%, #47B7E8 100%);\n}\n\n.enterposidcard {\n    background:\n        linear-gradient(276.1deg, #3A41C8 0.31%, #935FE5 100%);\n}\n\n.myApproval {\n    // grid grid-cols-12 border mt-[50px] p-[40px] rounded-[24px] `\n    border-radius: 24px;\n    padding: 20px 40px;\n    margin-top: 50px;\n    background: linear-gradient(276.1deg, #3A41C8 0.31%, #935FE5 100%);\n    display: flex;\n    color: white;\n    justify-content: space-between;\n    align-items: center;\n    height: 160px;\nimg{\n    height: 97px !important;\n}\n    .status {\n        //styleName: material-theme/body/medium;\n        font-family: Inter;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        text-align: center;\ncolor: #6D5E00;\nbackground-color: rgba(231, 205, 61, .8);\nborder-radius: 8px;\npadding: 0 5px;\nalign-items: center;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scanqrcard": `payvendor_scanqrcard__WY-kT`,
	"enterposidcard": `payvendor_enterposidcard__LvL3m`,
	"imgbox": `payvendor_imgbox__Xapg5`,
	"myApproval": `payvendor_myApproval__Qkqf1`,
	"status": `payvendor_status__CACc9`
};
export default ___CSS_LOADER_EXPORT___;
